import React, { useState } from 'react';
import { Box, Button, HStack, useToast } from '@chakra-ui/react';

export default function ResourceAction({
  defaults,
  onSubmit,
  FormComponent,
  buttonLabel,
}: {
  defaults: { defaults: Record<string, any>; options?: Record<string, any[]> };
  onSubmit: (data: Record<string, any>) => Promise<string>;
  FormComponent: React.ComponentType<any>;
  buttonLabel: string;
}) {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(defaults.defaults);
  const [submitting, setSubmitting] = useState(false);
  const toast = useToast();

  const submit = async () => {
    setSubmitting(true);
    try {
      const message = await onSubmit(formData);
      toast({ title: message, status: 'success', duration: 3000 });
    } catch (err: any) {
      const errors = err?.response?.data?.errors;
      const message =
        err?.response?.data?.message ||
        (errors
          ? Object.values(errors).flat().join(', ')
          : 'Unknown error');
      toast({ title: 'Failed', description: message, status: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <HStack spacing={2} mb={3}>
        <Button
          colorScheme="purple"
          size="sm"
          onClick={submit}
          isLoading={submitting}
        >
          {buttonLabel}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setEditing(!editing)}
        >
          {editing ? 'Hide Form' : 'Edit Defaults'}
        </Button>
      </HStack>

      {editing && (
        <Box mt={2} p={3} borderWidth={1} borderRadius="md" borderColor="gray.200">
          <FormComponent
            data={formData}
            options={defaults.options ?? {}}
            onChange={setFormData}
            onSubmit={submit}
            isSubmitting={submitting}
          />
        </Box>
      )}
    </>
  );
}
